const API_BASE = import.meta.env.VITE_API_URL;

const handleResponse = async (response: Response) => {
  if (response.status === 401) {
    window.dispatchEvent(new Event('auth:unauthorized'));
  }
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'API Request Failed');
  }
  return response.json();
};

export const organizationService = {
  async createOrganization(token: string, name: string, billingEmail?: string) {
    const response = await fetch(`${API_BASE}/organizations`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify({ name, billingEmail }),
    });
    return handleResponse(response);
  },

  async getOrganization(token: string, orgId: string) {
    const response = await fetch(`${API_BASE}/organizations/${orgId}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  async getAuditLogs(token: string, orgId: string) {
    const response = await fetch(`${API_BASE}/organizations/${orgId}/logs`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  async inviteUser(token: string, orgId: string, email: string, role: string) {
    const response = await fetch(`${API_BASE}/organizations/${orgId}/users`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify({ email, role }),
    });
    return handleResponse(response);
  },

  async updateRole(token: string, orgId: string, userId: string, role: string) {
    const response = await fetch(`${API_BASE}/organizations/${orgId}/users/${userId}/role`, {
      method: 'PATCH',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify({ role }),
    });
    return handleResponse(response);
  },

  async removeUser(token: string, orgId: string, userId: string) {
    const response = await fetch(`${API_BASE}/organizations/${orgId}/users/${userId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  async leaveOrganization(token: string, orgId: string) {
    const response = await fetch(`${API_BASE}/organizations/${orgId}/leave`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return handleResponse(response);
  }
};